<template>
    <section class="space-y-1">
        <form-label>{{ label }}</form-label>
        <p v-if="!items.length" class="text-xs text-gray-300">{{ empty }}</p>
        <div v-for="(item, index) in items" :key="item.wire.id"
            class="flex items-center gap-1 rounded border border-white/20 bg-white/5 px-1 py-0.5 text-xs">
            <button class="min-w-0 flex-1 truncate text-left hover:text-ui-active" :title="item.view.summary"
                @click="logic.select(page, 'node', item.node.id)">
                {{ item.view.icon }} {{ item.view.title }} <span class="text-gray-400">{{ item.view.summary }}</span>
            </button>
            <button class="text-gray-300 hover:text-ui-active disabled:opacity-30" :disabled="index === 0"
                title="Run earlier" @click="move(index, -1)">↑</button>
            <button class="text-gray-300 hover:text-ui-active disabled:opacity-30" :disabled="index === items.length - 1"
                title="Run later" @click="move(index, 1)">↓</button>
            <button class="text-red-300 hover:text-red-200" title="Disconnect" @click="logic.removeWire(page, item.wire.id)">×</button>
        </div>
    </section>
</template>

<script setup>
import { computed } from 'vue';
import { useLogicStore } from '../../stores/logicStore.js';
import { findNode, getOutputWires } from '../../logic/logicGraph.js';
import { describeLogicNode } from '../../logic/logicPresentation.js';

/** What one output of a condition or switch runs, in execution order, with ↑/↓ to reorder. */
const props = defineProps({
    page: { type: Object, required: true },
    graph: { type: Object, required: true },
    node: { type: Object, required: true },
    port: { type: String, required: true },
    label: { type: String, default: 'Runs (in order)' },
    empty: { type: String, default: 'Drag a wire from this output to an action.' },
});
const logic = useLogicStore();

const items = computed(() => getOutputWires(props.graph, props.node.id, props.port)
    .map(wire => ({ wire, node: findNode(props.graph, wire.to.node) }))
    .filter(item => item.node)
    .map(item => ({ ...item, view: describeLogicNode(item.node) })));

function move(index, delta) {
    const ids = items.value.map(item => item.wire.id);
    const [moved] = ids.splice(index, 1);
    ids.splice(index + delta, 0, moved);
    logic.reorderEventActions(props.page, props.node.id, ids);
}
</script>
